import { render, staticRenderFns } from "./TDstudent.vue?vue&type=template&id=f2dcc662"
import script from "./TDstudent.vue?vue&type=script&lang=js"
export * from "./TDstudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports